<template>
    <div class="agent-performance">
        <div class="chart-container">
            <div class="chart-header">
                <h5>
                    <i class="fal fa-users text-primary"></i> Rendimiento de
                    Agentes
                </h5>
                <!-- <a
                    href="#"
                    class="link-conexiones"
                    @click.prevent="toggleConnections"
                >
                    {{
                        showConnections
                            ? "Ocultar conexiones"
                            : "Ver conexiones"
                    }}
                    <i class="fal fa-arrow-right ml-1"></i>
                </a> -->
            </div>

            <div class="table-responsive">
                <table class="agent-table">
                    <thead>
                        <tr>
                            <th>AGENTE</th>
                            <th class="text-center">EN PROCESO</th>
                            <th class="text-center">RESUELTAS</th>
                            <th class="text-center">TOTAL</th>
                            <th class="text-center">VENCIDAS</th>
                            <th class="text-center">POR VENCER</th>
                            <th class="text-center">T. PROMEDIO</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="agente in agentePerformance"
                            :key="agente.nombre"
                        >
                            <td>
                                <div class="agent-info">
                                    <div
                                        class="agent-avatar"
                                        :style="{
                                            background: avatarColor(
                                                agente.nombre
                                            ),
                                        }"
                                    >
                                        {{ initialsOf(agente.nombre) }}
                                    </div>
                                    <div class="agent-name">
                                        {{ agente.nombre }}
                                    </div>
                                </div>
                            </td>
                            <td class="text-center">
                                <span class="cell-bubble bubble-progress">{{
                                    agente.en_proceso || 0
                                }}</span>
                            </td>
                            <td class="text-center">
                                <span class="cell-bubble bubble-done">{{
                                    agente.resueltas || 0
                                }}</span>
                            </td>
                            <td class="text-center">
                                <span class="cell-bubble bubble-total">{{
                                    agente.total || 0
                                }}</span>
                            </td>
                            <td class="text-center">
                                <span class="cell-bubble bubble-overdue">{{
                                    agente.vencidas || 0
                                }}</span>
                            </td>
                            <td class="text-center">
                                <span class="cell-bubble bubble-warning">{{
                                    agente.por_vencer || 0
                                }}</span>
                            </td>
                            <td class="text-center">
                                <span class="cell-bubble bubble-time">
                                    {{ agente.tiempo_promedio || 0 }}h
                                </span>
                            </td>
                        </tr>
                        <tr
                            v-if="
                                !agentePerformance ||
                                agentePerformance.length === 0
                            "
                        >
                            <td colspan="7" class="empty-row">
                                Sin agentes con solicitudes en el período
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="showConnections" class="mt-3">
                <agent-connections :period="period" :from="from" :to="to" />
            </div>
        </div>
    </div>
</template>

<script>
import AgentConnections from "./AgentConnections.vue";

export default {
    name: "AgentPerformance",
    components: { AgentConnections },
    props: {
        agentePerformance: {
            type: Array,
            default: () => [],
        },
        period: { type: String, default: "mes" },
        from: { type: String, default: null },
        to: { type: String, default: null },
    },
    data() {
        return {
            showConnections: false,
            avatarPalette: [
                "#3b82f6",
                "#10b981",
                "#f59e0b",
                "#8b5cf6",
                "#ef4444",
                "#06b6d4",
                "#ec4899",
                "#14b8a6",
                "#f97316",
                "#6366f1",
            ],
        };
    },
    methods: {
        toggleConnections() {
            this.showConnections = !this.showConnections;
        },
        initialsOf(nombre) {
            if (!nombre) return "?";
            const clean = String(nombre)
                .replace(/^(Lic\.|D\.|Sr\.|Sra\.|Dr\.|Dra\.)\s+/i, "")
                .trim();
            const parts = clean.split(/\s+/);
            const first = parts[0] ? parts[0].charAt(0) : "";
            const last =
                parts.length > 1 ? parts[parts.length - 1].charAt(0) : "";
            return (first + last).toUpperCase();
        },
        avatarColor(nombre) {
            if (!nombre) return this.avatarPalette[0];
            let hash = 0;
            for (let i = 0; i < nombre.length; i++) {
                hash = (hash << 5) - hash + nombre.charCodeAt(i);
                hash |= 0;
            }
            const idx = Math.abs(hash) % this.avatarPalette.length;
            return this.avatarPalette[idx];
        },
    },
};
</script>

<style scoped>
.agent-performance {
    margin-bottom: 30px;
}

.chart-container {
    background: #ffffff;
    border-radius: 14px;
    padding: 22px 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    margin-bottom: 20px;
}

.chart-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
}

.chart-header h5 {
    color: #1f2937;
    font-weight: 600;
    margin: 0;
}

.link-conexiones {
    color: #3b82f6;
    font-size: 0.88rem;
    font-weight: 500;
    text-decoration: none;
}

.link-conexiones:hover {
    color: #2563eb;
    text-decoration: none;
}

/* Tabla */
.agent-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
}

.agent-table thead th {
    border: none;
    border-bottom: 1px solid #e5e7eb;
    background: transparent;
    color: #6b7280;
    font-weight: 600;
    font-size: 0.7rem;
    letter-spacing: 0.5px;
    padding: 10px 12px;
    text-transform: uppercase;
    white-space: nowrap;
}

.agent-table tbody td {
    border: none;
    border-bottom: 1px solid #f3f4f6;
    padding: 14px 12px;
    vertical-align: middle;
    font-size: 0.9rem;
    color: #374151;
}

.agent-table tbody tr:last-child td {
    border-bottom: none;
}

.agent-table tbody tr:hover {
    background: #fafbfc;
}

.text-center {
    text-align: center;
}

/* Avatar */
.agent-info {
    display: flex;
    align-items: center;
    gap: 12px;
}

.agent-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 0.78rem;
    flex-shrink: 0;
    letter-spacing: 0.5px;
}

.agent-name {
    font-weight: 500;
    color: #111827;
    line-height: 1.3;
}

/* Bubbles (badges circulares ligeros) */
.cell-bubble {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    height: 28px;
    padding: 0 10px;
    border-radius: 999px;
    font-weight: 600;
    font-size: 0.82rem;
    background: #f3f4f6;
    color: #374151;
}

.bubble-pending {
    background: #fef3c7;
    color: #b45309;
}

.bubble-progress {
    background: #dbeafe;
    color: #1d4ed8;
}

.bubble-done {
    background: #d1fae5;
    color: #047857;
}

.bubble-total {
    background: #e0e7ff;
    color: #4338ca;
}

.bubble-overdue {
    background: #fee2e2;
    color: #b91c1c;
}

.bubble-warning {
    background: #fef3c7;
    color: #b45309;
}

.bubble-time {
    background: #ccfbf1;
    color: #0f766e;
}

/* Estado */
.status-pill {
    display: inline-block;
    padding: 4px 14px;
    border-radius: 999px;
    font-size: 0.78rem;
    font-weight: 600;
}

.status-active {
    background: #d1fae5;
    color: #047857;
}

.status-offline {
    background: #fee2e2;
    color: #b91c1c;
}

.empty-row {
    text-align: center;
    color: #9ca3af;
    padding: 30px 0;
    font-size: 0.9rem;
}

@media (max-width: 768px) {
    .chart-container {
        padding: 16px;
    }
    .agent-table tbody td {
        font-size: 0.8rem;
        padding: 10px 8px;
    }
    .agent-table thead th {
        font-size: 0.65rem;
        padding: 8px;
    }
    .agent-avatar {
        width: 30px;
        height: 30px;
        font-size: 0.7rem;
    }
    .agent-name {
        font-size: 0.85rem;
    }
    .cell-bubble {
        min-width: 26px;
        height: 24px;
        font-size: 0.75rem;
        padding: 0 8px;
    }
    .status-pill {
        font-size: 0.7rem;
        padding: 3px 10px;
    }
}
</style>
